import React from 'react'
import NavbarSidebarWrapper from '../../../components/navbarSidebarWrapper';
import SMGamesTable from './SMGamesTable';

const SMAllGames = () => {
  return (
    <NavbarSidebarWrapper>
      <SMGamesTable />
    </NavbarSidebarWrapper>
  )
}

export default SMAllGames;
